/*global
    jQuery
*/
(function($){

    'use strict';

    //Step 1
    function toggleSubmit() {
        /*jshint validthis: true */
        var isOtherPet = $('#pet_type').val() === 'none',
            isNotSpayed = $('#spayed_neutered').val() === 'none',
            $submitButton = $('#easy_step1_submit');

        if(isOtherPet || isNotSpayed) {
            $submitButton.prop('disabled', true);
        } else {
            if ( !$submitButton.is(':disabled') ) {
                $submitButton.prop('disabled', false);
            }
        }
    }

        var togglePureBred = function() {
            console.log('triggered purebred toggle');
            var $breed = $('#edit-pets-form').find('select[name="breed"]');
            var $secondBreed = $('#edit-pets-form').find('select[name="second_breed"]');
            var $purebred = $('#edit-pets-form').find('input[name="purebred"]');

            console.log($breed.val());
            console.log($secondBreed.val());
            console.log($purebred);
            console.log($purebred.is(':checked'));

            if (typeof $secondBreed === 'undefined' || $secondBreed.length === 0) {
                return false;
            }

            if ($breed.val() !== '' && $secondBreed.val() === '') {
                if (!$purebred.is(':checked')) {
                    console.log('Checked? Really?');
                    $purebred.click();
                }
            } else if ($breed.val() === '' && $secondBreed.val() === '') {
                if ($purebred.is(':checked')) {
                    console.log('should not be checked');
                    $purebred.click();
                }
            } else if ($breed.val() !== '' && $secondBreed.val() !== '') {
                if ($purebred.is(':checked')) {
                    console.log('should not be checked 2');
                    $purebred.click();
                }
            }
        }    

    //Step 4 validationErrors
    function submitField() {
        /*jshint validthis: true */
        var showLoading = true;
        var $field = $(this),
            $form = $field.parents('form'),
            url = $form.data('validation_url'),
            data = $field.serialize(),
            $error = $field.parents('.field-div').find('span.error'),
            fieldName = this.id;

        if ($field.attr('name') == 'savePet') {
            return false;
        }

        if (typeof ga !== 'undefined') {
            console.log('found ga');
            var label = fieldName + ' changed';
            if (typeof fieldName == 'undefined' || fieldName == '') {
                label = $field.attr('name') + ' changed';
            }
            console.log(label);
            ga('send', 'event', 'Owner Dashboard', 'Edit Field For Pet', label);
        }

        if(fieldName === 'dummy_breed' || fieldName === 'dummy_second_breed') {
            data = $field.parents('.field-div').find('input:hidden').serialize();
            fieldName = $field.parents('.field-div').find('input:hidden').attr('id');
        }

        if(fieldName == 'dummy_shelter') {
            data = $field.parents('div').find('input[name="dummy_shelter"], input[name="donation_shelter_rescue"], input[name="shelter_zip"]').serialize();
            //fieldName = 'donation_shelter_rescue';
        }

        if ($field.hasClass('checkbox')) {
            var result = $field.is(':checked') ? 1 : 0;
            if ( data === '' ) {
                data += fieldName + '=' + result;
            } else {
                data += '&' + fieldName + '=' + result;
            }
        }

        function displayError(d) {
            var errorMessage = d.responseJSON[fieldName][0];
            $error.text(errorMessage).show();
            $field.addClass('error');
            hideLoadingGraphic($field.parent('div'));
        }

        function removeError() {
            $error.empty().hide();
            $field.removeClass('error');
            hideLoadingGraphic($field.parent('div'));
            togglePureBred();
        }

        function showSuccess() {
            var n = noty({
                type: 'success',
                timeout: 2000,
                text: 'Changes saved!'
            });
        }

        function insertLoadingGraphic(elem) {
            elem.parents('form').append('<div class="loading-overlay"></div>');
        }

        function showLoadingGraphic(elem) {
            var loadingGraphic = elem.parents('form').find('div.loading-graphic');
            
            setTimeout(function () {
                if ( showLoading ) {
                    elem.parents('form').prop('disabled', true);
                    if (typeof loadingGraphic === 'undefined' || loadingGraphic.length == 0) {
                        insertLoadingGraphic(elem);
                    } else {
                        elem.parents('form').find('div.loading-overlay').css('display', 'block');
                    }
                }
            }, 200);
        }

        function hideLoadingGraphic(elem) {
            showLoading = false;
            elem.parents('form').prop('disabled', false);
            elem.parents('form').find('div.loading-overlay').css('display', 'none');
        }

        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            headers:{
                'X-CSRF-TOKEN': $form.find('input[name="_token"]').val()
            },
            beforeSend: function() {
                showLoadingGraphic($field.parent('div'));
            },
            success: function(data,status) {
                //hideLoadingGraphic($field.parent('div'));
                if ( data !== undefined && data.status !== undefined && data.status == 'success'  && $('div.is_owner_edit_pet').length > 0) {
                    //showSuccess();
                    showCheckMark($field);
                }
            },
        }).done(removeError).fail(displayError);
    }

    //Step 4 Submission
    function submitPet(e) {
        /*jshint validthis: true */
        var $form = $(this),
            url = $form.data('submission_url');

            $.ajax({
                type: 'POST',
                url: url,
                data: $form.serialize(),
                headers:{
                    'X-CSRF-TOKEN': $form.find('input[name="_token"]').val()
                },
            });


        e.preventDefault();
    }

    // Save on unload
    var saveOnUnload = function(e) {
        var $focused = $(':focus');
        $focused.blur();
    }

    var showCheckMark = function(e) {
        //var $wrapper = e.parents('div.field-div');
        //$wrapper.prepend('<img role="img" style="max-height:20%; max-width=20%;" class="field-saved" src="/img/modules/checkmark.svg" />');
        if ( e.is('input') || e.is('select') ) {
            console.log('running');
            e.addClass('ajax-save-success');

            setTimeout(function () {
                //$wrapper.find('img.field-saved').remove();
                e.removeClass('ajax-save-success');
            }, 1500);
        }
    }

    $(window).on('beforeunload', saveOnUnload);
    $('#pet_type').on('change', toggleSubmit);
    $('#spayed_neutered').on('change', toggleSubmit);

    $('#pet_submission_easy').on('submit', submitPet);
    $('#pet_submission_easy').find('input').on('blur', submitField);
    $('#pet_submission_easy').find('select').on('change', submitField);
    
    $('#edit-pets-form').find('input').on('blur', submitField);
    $('#edit-pets-form').find('input[type="checkbox"]').on('change', submitField);
    $('#edit-pets-form').find('select').on('change', submitField);
    $('#edit-pets-form').find('textarea').on('blur', submitField);

    $('input[name="savePet"]').on('click', function(e) {
        console.log('clicked');
        var data = $('form#edit-pets-form').serialize();
        var pet_id = $('input[name="pet_id"]').val();

        $.ajax({
            url: '/pet/edit/savepet/'+pet_id,
            type: 'post',
            data: data,
            success: function(response) {
                console.log(response);
                window.location.reload();
            },
            error: function(response) {
                console.log(response);
            }
        });
    });
    // Pet Edit field specific JS, cleanup needed TODO
    $(document).ready(function() {
        var $rehomeReason = $('#edit-pets-form').find('select[name="rehome_reason"]');
        var $rehomeCustom = $('#edit-pets-form').find('input[name="rehome_reason_custom"]');
        if($rehomeReason.val() === 'none') {
            $rehomeCustom.parent('div').removeClass('closed');
        } else {
            $rehomeCustom.parent('div').addClass('closed');
        }

        $('span.error').hide();
    });

    //$(window).on('load', function() {

    //    setTimeout(function() {
    //        $(window).scrollTop(0);
    //    }, 10);
    //});

    //hide progress if flow is Easy on Step 3
    if(location.pathname.split('/').reverse()[1] === 'list-a-pet') {
        $('.progress').hide();
    }

}(jQuery));
